module.exports = __webpack_public_path__ + "img/2021_1_7_slug.b480c368.jpg";